import type { useI18n } from "../i18n/useI18n"
import type { ValidatorIssue } from "../schemas"

function getLevel(issue: ValidatorIssue): number | null {
  const pathMatch = issue.path?.match(/progression\[(\d+)\]/u)
  if (pathMatch) {
    return Number.parseInt(pathMatch[1] ?? "", 10) + 1
  }

  const messageMatch = issue.message.match(/level (\d+)/iu)
  if (messageMatch) {
    return Number.parseInt(messageMatch[1] ?? "", 10)
  }

  return null
}

function getQuotedSkillId(issue: ValidatorIssue): string | null {
  const match = issue.message.match(/"([^"]+)"/u)
  return match?.[1] ?? null
}

function getMaxSkills(issue: ValidatorIssue): number | null {
  const match = issue.message.match(/at most (\d+) skills/u)
  return match ? Number.parseInt(match[1] ?? "", 10) : null
}

export function getHeroValidationIssueLabel(
  t: ReturnType<typeof useI18n>["t"],
  issue: ValidatorIssue,
): string {
  const level = getLevel(issue)
  const skillId = getQuotedSkillId(issue) ?? t("common.unknown")

  switch (issue.code) {
    case "HERO_DUPLICATE_COLOR":
      return t("heroEditor.validation.duplicateColor")
    case "HERO_INVALID_PROGRESSION_ORDER":
      return t("heroEditor.validation.invalidProgressionOrder")
    case "HERO_SKILL_AFFINITY_MISMATCH":
      return t("heroEditor.validation.skillAffinityMismatch", {
        level: level ?? t("common.unknown"),
        skillId,
      })
    case "HERO_TOO_MANY_SKILLS":
      return t("heroEditor.validation.tooManySkills", {
        level: level ?? t("common.unknown"),
        max: getMaxSkills(issue) ?? 3,
      })
    case "HERO_UNKNOWN_SKILL":
      return t("heroEditor.validation.unknownSkill", {
        level: level ?? t("common.unknown"),
        skillId,
      })
    default:
      return issue.message
  }
}
